import { z } from 'zod/v4';

export const CompanyEmbeddingSchema = z.object({
  id: z.string(),
  companyId: z.string().max(36),
  embedding: z.array(z.number()),
  originalText: z.string().max(1024),
  composedOf: z.array(z.string()),
  createdAt: z.date(),
  model: z.string().max(64),
});

export type CompanyEmbedding = z.infer<typeof CompanyEmbeddingSchema>;
